<template>
    <label :class="['totem-input-label', { required: isRequired }, { 'bold': bold }]">
        <slot />
    </label>
</template>

<script>
    export default {
        name: 'totem-input-label',
        props: {
            isRequired: {
                type: Boolean,
                default: false
            },
            bold: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-input-label {
        font-size: 1.4rem;
        font-family: PlusJakartaSans-Regular, sans-serif;
        display: block;
        margin: 6px 0;
        line-height: 1.9rem;

        &.bold {
            font-size: 1.6rem;
            font-family: PlusJakartaSans-Bold, sans-serif;
            margin: 10px 0;
        }

        &.required {
            &:after {
                content: ' *';
            }
        }
    }
</style>
